module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "list  ",
      class: {
        active: item.isCheckDetail
      }
    }, [_c('div', {
      staticClass: "top flex"
    }, [_c('div', {
      staticClass: "l "
    }, [_c('h1', {
      staticClass: "public-red"
    }, [_c('span', [_vm._v("￥")]), _vm._v(_vm._s(item.deduct_money))]), _vm._v(" "), _c('span', {
      staticClass: "public-gray"
    }, [_vm._v("满￥" + _vm._s(item.limit_money) + "立减")])]), _vm._v(" "), _c('div', {
      staticClass: "flex-1 r"
    }, [_c('span', {
      staticClass: "title text-l ellipsis-1"
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), _c('span', {
      staticClass: "public-red text-r",
      on: {
        "click": function($event) {
          _vm.receive(item)
        }
      }
    }, [_vm._v("点击领取")]), _vm._v(" "), _c('div', {
      staticClass: "flex btm"
    }, [_c('span', {
      staticClass: "public-gray"
    }, [_vm._v(_vm._s(_vm._f("timerForm")(item.cansend_end_time, 'YYYY-MM-DD')) + "到期")]), _vm._v(" "), _c('span', {
      staticClass: "color-666",
      on: {
        "click": function($event) {
          _vm.detailTap(item)
        }
      }
    }, [_vm._v("详情")])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isCheckDetail),
        expression: "item.isCheckDetail"
      }],
      staticClass: "box-btm text-l public-gray"
    }, [_c('p', [_vm._v("优惠券名称：" + _vm._s(item.coupon_name))]), _vm._v(" "), _c('p', [_vm._v("优惠券描述：" + _vm._s(item.coupon_desc))]), _vm._v(" "), _c('p', [_vm._v("适用会员：" + _vm._s(item.grade_name))]), _vm._v(" "), _c('p', [_vm._v("使用时间：" + _vm._s(_vm._f("timerForm")(item.canuse_start_time, 'YYYY.MM.DD')) + " - " + _vm._s(_vm._f("timerForm")(item.canuse_end_time, 'YYYY.MM.DD')))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065a76fb"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeCoupon/list.vue
// module id = 511
// module chunks = 0